var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "47px",
    height: "32px",
    viewBox: "0 0 468 318",
    style: {
      enableBackground: "new 0 0 468 318"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      fill: url(#SVGID_1_);\n    }\n  ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.9,
    y1: 334.2016,
    x2: 233.9,
    y2: 77.7991,
    gradientTransform: "matrix(1 0 0 -1 0 320)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAB721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08025751,
    style: {
      stopColor: "#FAB721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F38620"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.3,17.5v41.9c0,1.6,1.3,2.9,2.9,2.9h25.1c2.2,0,3.6,2.4,2.5,4.3L236.4,145 c-1.1,1.9-3.8,1.9-4.9,0l-45.3-78.5c-1.1-1.9,0.3-4.3,2.5-4.3H214c1.6,0,2.9-1.3,2.9-2.9V17.4H105.6c-2.2,0-3.6,2.4-2.5,4.3 L231.5,244c1.1,1.9,3.8,1.9,4.9,0L364.7,21.7c1.1-1.9-0.3-4.3-2.5-4.3L251.3,17.5L251.3,17.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b99532e03b945190f1c652ac34d2623c.svg";
export { ForwardRef as ReactComponent };